import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dedicated-hosting',
  templateUrl: './dedicated-hosting.component.html',
  styleUrls: ['./dedicated-hosting.component.scss']
})
export class DedicatedHostingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
